module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Three")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Adamant, Arkansas")])])])]), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("E")])])])]), _vm._v("sme Floyd prowled her tiny house, her arthritic knees protesting every step. She didn’t know why she was so uneasy tonight, but she reckoned the weather had something to do with it. Not a fit night out for man or beast, her mama would have said.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But even on mild nights, Esme sometimes stayed up until all hours. Came from all those years of waiting for her son, Robert, to come dragging in at dawn, and then later, her grandbaby, Curtis, although he’d never been as bad as his daddy to lay out.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Not until that one winter…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Esme pursed her lips. She wouldn’t study on that tonight. What would be the point?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Whatever devil had been riding the boy all those years ago was gone now. He’d turned into such a "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("fine")])]), _vm._v(" young man. A doctor, of all things! Esme was so proud, she could strut. Not a single generation of Floyds had ever made it through high school, let alone college and medical school. Robert had quit in the ninth grade and by the time he’d turned twenty-one, he’d served time in Cummins.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Esme had no idea where her son was now. Dead, for all she knew. He took off right after he got out of the pen, leaving Curtis and the boy’s mama to fend for themselves. Esme had ended up raising the child from the time he was twelve years old. He’d been a couple of years older than Rachel when he came here to live, but the two became thick as thieves once he let down his guard.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Thankfully, the DeLaunes hadn’t minded him being around. Esme had been especially worried about James who was mighty particular about Rachel’s friends. The family had been good to her, and she would have hated giving up her job. But Curtis had always been a quiet, easygoing boy, even when he was little, and he’d had enough sense to make himself scarce when he needed to.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Except when it came to Rachel.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("That trouble had started brewing right from the get-go, but Esme hadn’t the heart to take away the one good thing in her grandbaby’s life. So she’d sat back and watched his friendship with Rachel DeLaune turn into fierce devotion and later, heartbreak when the girl moved on to someone more suitable.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Esme had worried then, as she still sometimes worried on nights when she couldn’t sleep, that Curtis’s attachment to Rachel might have crossed the line into obsession.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But it didn’t much matter now. Rachel was dead, God rest her soul; had been for fourteen years.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her killer had never been caught, but most folks in Adamant had their suspicions. The body had been found at the old Duncan farmhouse where Buddy Fears’s boy used to hang out. Esme had seen him out there herself, lollygagging about with that no-account bunch he ran with.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Smoking dope and God only knows what. Nothing but trouble, every last one of ’em.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Derrick Fears had been the worst of the lot. Not a lick of respect for his elders, or even his own body, what with all those piercings and tattoos. Marks of the devil, Esme thought with a shiver.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("William Clay had been the county sheriff back then, and she’d heard him tell James once that he knew in his gut that pack of degenerates had killed Rachel, probably during some devil-worshipping ritual out at the farmhouse. And if it took him the rest of his life, he’d see them boys fry.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But it didn’t work out that way. Sheriff Clay had gone to his grave beaten and weary, Rachel’s murder the only black mark against an otherwise outstanding career.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And all these years later, the killer was still out there.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Esme tried to turn away from her dark thoughts. She got out her Bible, but she was too jittery to read. And her joints were starting to ache. The arthritis in her knees and shoulders was getting worse all the time.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Curtis had been after her to retire ever since he’d come back home to work at the hospital in El Dorado, but to Esme, retirement was one step away from the old folks’ home. She wasn’t so stove up yet she couldn’t make herself useful.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Setting aside the Bible, she got up and padded on bare feet to the bathroom to get a glass of water. She wouldn’t take her medicine just yet. Not until the pain got so bad she couldn’t stand it. She was too afraid of getting hooked on the pills.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She went into her bedroom, but instead of crawling under the warm layers of blankets, she shuffled over to the window to look out. The night was clear and cold, the moon so bright she could see ice glistening on the barren tree branches.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her cottage window faced the back of the DeLaune house, and she stood for a moment admiring its graceful lines through the tree branches. Oh, how she loved that place. Over a hundred years old and still just as regal and elegant as she remembered it from her childhood.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Thomas Duncan’s daughter had lived in the house, and Esme remembered when the old man had moved in with her. By then, his hair had been as white and wispy as cotton, his eyes frosted with cataracts. He’d sit in a cane rocker on the veranda for hours, mumbling to himself, paying no mind to the taunting neighborhood children who called him Crazy Ol’ Tom.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Esme used to see him out there on Sunday mornings when she and her mama walked home from church. Sometimes his two little granddaughters would be playing in the yard and Esme would stop to watch.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Stop that gawkin’, Esme Louise,” Mama would scold with her lips pooched out in stern disapproval. “You act like you ain’t never seen old folk before.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But it wasn’t Thomas who fascinated Esme; it was the two little girls who always seemed to be dressed in white.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“How come they don’t never get dirty, Mama?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“They do get dirty, child, what a foolish notion. They get dirty same as the rest of us. Only difference is, they got somebody to wash up after ’em.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I wanna live in a house like that, Mama.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Esme Louise, the only way you ever gonna live in a house like that is if you the one doin’ the washin’ up. And that ain’t in the cards for you, baby girl, ’cuz I mean for you to get an education. Then you can go to Little Rock or Memphis and get yourself a "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("real")])]), _vm._v(" job. Make your own way. I don’t want you havin’ to do for nobody but yourself.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Esme hadn’t said anything, but she’d thought to herself that it wouldn’t be so bad washing clothes and scrubbing floors if she could live in a place like that. She didn’t mind housework, not even the ironing that her mama took in.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Anything was better than field work. Chopping cotton under a blistering sun in the summer and picking up pecans in the fall and winter when the ground was cold and wet and cockleburs stuck to your hair and clothes like prickly brown leeches.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Spring was the only time Esme enjoyed being outdoors, before the cloying heat of summer settled like a wool blanket over the countryside, while the air was still drowsy with roses and lilacs, and strawberries lay hidden like Easter eggs in lush, dewy vines.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her mama had died in the springtime.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Esme had just turned thirteen, and she’d left school to take care of her younger brother and sisters. She’d married at sixteen, had a baby at seventeen and was widowed by the time she turned twenty.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When James and Anna DeLaune moved into the house as newlyweds, Esme had already been working there for years. James had paid her a visit, hat in hand, one Saturday afternoon and asked if she would please stay on and help them out. His young wife was frail and couldn’t handle that big place all by herself. Esme had been there ever since.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Forty years she’d spent taking care of that house, and for the most part, she’d been content with her work. But after Rachel’s death, everything changed. A terrible darkness had settled over the place.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("James had doted on that girl—everyone did—and once she was gone, he couldn’t bear to step foot inside. He’d spent most of his time holed up in his chambers at the county courthouse, ignoring the needs of his troubled child and heartsick wife.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Anna hadn’t been strong enough to carry the burden of her grief alone. She’d died a few months later. They said it was heart trouble, but Esme had her doubts. Anna had been a young woman, only thirty-six, and Esme suspected that Doc Washington had fudged the death certificate out of compassion for a family already broken by grief and guilt.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Esme had wondered then—and she would wonder until the day she died—if Anna DeLaune had deliberately taken her own life, leaving her youngest behind to deal with the sorrow in the only way she knew how.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Poor child.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sarah had always been such a puzzle to Esme. She’d never had any friends to speak of. Didn’t give a hoot about parties and sleepovers the way Rachel had. Instead, she’d spent her time roaming the countryside by herself, sometimes at all hours.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("And those eyes…")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Lord have mercy, the way that girl could look at you would lift the hair right up off the back of your neck.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But for all her peculiar ways, Sarah had been Esme’s favorite. Maybe because of the way her daddy treated her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Never made any bones about who")])]), _vm._v(" his "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("favorite was.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("After the funeral, Sarah had closed herself off. Wouldn’t talk to a soul about what happened. Even the special doctor called in by Sheriff Clay couldn’t unlock the secrets trapped in that child’s memory. But there were nights, while in the grip of a nightmare, that she would whisper a name.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sometimes it seemed to Esme that, if she listened closely enough, she could still hear that name in the wind.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Shivering from the cold seeping in through the window, she lifted her gaze to the roof where moonlight glinted off a thin layer of snow. For a moment…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She blinked and looked again. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Jesus Lord")])]), _vm._v(".")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Someone was up there.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She could barely see him against the backdrop of night sky, but he was there, a nebulous form moving quickly up the slanting roof.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The glass slipped from Esme’s hand and shattered against the cold, tile floor. Shards bit into her bare feet, but she paid scant attention to the pain. Her focus was still on the roof.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He must have been stooped over before, because now he rose up against the moonlight, a towering silhouette with a pale face and dark-rimmed eyes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Esme tried to scoff at herself. She couldn’t see that kind of detail in the dark. It was nothing more than an old woman’s superstition.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But he was there. No matter how much she wished to deny it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And in the split second before he bounded over the peak and disappeared on the other side of the roof, Esme could have sworn he’d seen her, too. She could feel the heat of his eyes burning into her soul.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ac002b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/devilsfootprintsthe_ch03.vue
// module id = 78
// module chunks = 0